import React from "react";

import type {FormContextValues} from "./useForm";
import {FormContext} from "./useForm";

function useFormContext<TFieldValues>() {
    const context = React.useContext(FormContext) as FormContextValues<TFieldValues>;
    if (!context) {
        throw new Error("useFormContext must be used within a FormContext");
    }
    return context;
}

export default useFormContext;
